module.exports = __webpack_public_path__ + "media/images/gallery/constellations/capricornus/cap_lines-23f3881dd441b5a4b2b71db1316d5722.gif";